export default __webpack_public_path__ + "static/media/15.32c6e81d.png";